import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/lib/trpc";

export const useNotificationQueryOptions = ({ id }: { id: number }) => {
    const trpc = useTRPC();
    const opts = trpc.notification.get.queryOptions(id, {
        staleTime: 0,
        gcTime: 0,
    });
    return opts;
};

export const useNotificationCount = () => {
    const trpc = useTRPC();
    const opts = trpc.notification.notificationCount.queryOptions(undefined, {
        staleTime: 5000,
        gcTime: 5000,
        refetchOnWindowFocus: true,
        refetchInterval: 60000, // every minute
    });
    return useQuery(opts);
};
